import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { ReduxEntity, RegistrationSetting } from 'Douleutaras/types';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { RootState } from 'Douleutaras/redux/store';

const REGISTRATION_SETTINGS_ENDPOINT = 'api/public/registration_settings';

const registrationSettingsAdapter = createEntityAdapter();

export const getRegistrationSettings = createAsyncThunk(
  'settings/registrationSettings/get',
  async (arg = undefined, api) => {
    const response = await makeRequest(
      `${REGISTRATION_SETTINGS_ENDPOINT}/`,
      { method: 'GET' }
    )(api);

    return response.data.results;
  }
);

export const cancelRegistrationSettings = createAsyncThunk(
  'settings/billing/delete',
  async ({ id }: { id: string }, api) => {
    const response = await makeRequest(
      `${REGISTRATION_SETTINGS_ENDPOINT}/${id}/`,
      {
        method: 'DELETE'
      }
    )(api);

    return id;
  }
);

export const updateRegistrationSettings = createAsyncThunk(
  'settings/billing/update',
  async ({ id, product }: { id: string; product: number }, api) => {
    const response = await makeRequest(
      `${REGISTRATION_SETTINGS_ENDPOINT}/${id}/`,
      {
        method: 'PATCH',
        body: {
          product
        }
      }
    )(api);

    return response.data;
  }
);

export const registrationSettingsSlice = createSlice({
  name: 'registrationSettings',
  initialState: registrationSettingsAdapter.getInitialState({
    loading: false,
    error: false,
    entities: []
  } as ReduxEntity<RegistrationSetting>),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getRegistrationSettings.pending, state => {
      state.loading = true;
    });
    builder.addCase(getRegistrationSettings.fulfilled, (state, action) => {
      state.loading = false;
      registrationSettingsAdapter.setMany(state, action.payload);
    });
    builder.addCase(cancelRegistrationSettings.fulfilled, state => {
      registrationSettingsAdapter.removeAll(state);
    });
    builder.addCase(updateRegistrationSettings.fulfilled, (state, action) => {
      registrationSettingsAdapter.setOne(state, action.payload);
    });
  }
});

export const registrationSettingsSelector = registrationSettingsAdapter.getSelectors<RootState>(state => state.registrationSettings);
